
// Truncates a string on the given max length
export const truncate = (text: string | null | undefined, maxLength: number) => {
    if (!text) return "";

    if (text.length <= maxLength) return text;

    const trimmed = text.slice(0, maxLength);
    const lastSpace = trimmed.lastIndexOf(" ");

    return (lastSpace > 0 ? trimmed.slice(0, lastSpace) : trimmed) + "...";
};